// removed by extract-text-webpack-plugin
module.exports = {"Layout":"Layout__Layout__1E5WY"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Layout.css
// module id = 116
// module chunks = 0